module.exports = __webpack_public_path__ + "static/media/age-icon.5e798186.svg";